import { fluid } from '@helpers/fluid';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import ButtonStyles from '@stories/Components/Global/Buttons/Button/Button.styles';
import styled, { createGlobalStyle } from 'styled-components';
const GlobalStyles = createGlobalStyle `
  :root {
    --headerHeight: ${fluid(60, 90)} !important;
  }
`;
const Container = styled.header `
  --separatorColor: var(--accentColorPrimary);
  --textColor: var(--fgColor);

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid var(--separatorColor);
  background-color: var(--bgColor);
  z-index: 9;
`;
const Inner = styled.div `
  ${siteWide};
  ${baseGrid};

  align-items: center;
  height: var(--headerHeight);
`;
const LogoWrapper = styled.a `
  display: block;
  grid-column: 1 / span 2;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 3;
  }
`;
const Logo = styled.img `
  display: block;
  max-height: ${fluid(40, 52)};
`;
const ActionWrapper = styled.div `
  grid-column: 3 / span 2;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${fluid(18, 36)};

  @media ${from(Device.Tablet)} {
    grid-column: 4 / span 5;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 5 / span 8;
  }

  ${ButtonStyles.Container} {
    white-space: nowrap;

    @media ${until(Device.Tablet)} {
      --buttonSize: 42px;
    }

    @media ${from(Device.Tablet)} {
      &::before {
        content: attr(data-prefix);
        order: -1;
      }
    }
  }

  ${ButtonStyles.IconWrapper} > svg {
    height: 20px;
  }
`;
const HeaderReducedStyles = {
    ActionWrapper,
    Container,
    GlobalStyles,
    Inner,
    Logo,
    LogoWrapper,
};
export default HeaderReducedStyles;
